import { render, staticRenderFns } from "./accordion-city-of-arrival.vue?vue&type=template&id=1ef9e22c"
import script from "./accordion-city-of-arrival.js?vue&type=script&lang=js&external"
export * from "./accordion-city-of-arrival.js?vue&type=script&lang=js&external"
import style0 from "./accordion-city-of-arrival.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports